<div class="bgList">
    <img [ngClass]="{active : i == activeIndex }" [src]="item" *ngFor="let item of pageBgList; let i = index;" alt="">
</div>